import _ from 'lodash'

export const getBossTeamId = (allUser: any, bossEmail: string): string => {
  if (!allUser || !bossEmail) return ''
  const bossKey = bossEmail.replace(/\./g, '||')
  return (allUser[bossKey] && allUser[bossKey].team) ? allUser[bossKey].team : ''
}

export const shouldAutoSetParent = (args: {
  allUser: any,
  teamId: string,
  currentParent: string,
  userOverrides: Record<string, { team: string, boss: string }>
}) => {
  const managerTeamIds = new Set<string>()
  const allUserSafe = args.allUser || {}
  const overrideKeys = new Set(Object.keys(args.userOverrides || {}))

  _.forOwn(allUserSafe, (user: any, userKey: string) => {
    const override = args.userOverrides[userKey]
    const targetTeam = override ? override.team : user.team
    const bossEmail = override ? override.boss : user.boss
    if (targetTeam !== args.teamId || !bossEmail) return
    const bossTeam = getBossTeamId(allUserSafe, bossEmail)
    if (bossTeam && bossTeam !== args.teamId) {
      managerTeamIds.add(bossTeam)
    }
  })

  overrideKeys.forEach((userKey) => {
    if (allUserSafe[userKey]) return
    const override = args.userOverrides[userKey]
    if (!override || override.team !== args.teamId || !override.boss) return
    const bossTeam = getBossTeamId(allUserSafe, override.boss)
    if (bossTeam && bossTeam !== args.teamId) {
      managerTeamIds.add(bossTeam)
    }
  })

  const managerTeams = Array.from(managerTeamIds)
  if (managerTeams.length === 1) {
    return { shouldUpdate: true, parentId: managerTeams[0] }
  }
  if (managerTeams.length > 1) {
    if (args.currentParent) {
      return { shouldUpdate: false, parentId: '' }
    }

    const triggerBossTeamIds = new Set<string>()
    const overrideSafe = args.userOverrides || {}
    Object.keys(overrideSafe).forEach((userKey) => {
      const override = overrideSafe[userKey]
      if (!override || override.team !== args.teamId || !override.boss) return
      const bossTeam = getBossTeamId(allUserSafe, override.boss)
      if (bossTeam && bossTeam !== args.teamId) triggerBossTeamIds.add(bossTeam)
    })

    const triggerTeams = Array.from(triggerBossTeamIds)
    if (triggerTeams.length > 0) {
      return { shouldUpdate: true, parentId: triggerTeams[0] }
    }
  }
  return { shouldUpdate: false, parentId: '' }
}
